import script from "./SfxCardNotificationSystem.vue?vue&type=script&setup=true&lang=ts"
export * from "./SfxCardNotificationSystem.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QImg});
